import axios from "axios";

export const getEcardDetails = async (promotionId) => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  const appToken = localStorage.getItem("appToken");
  return await axios.get(
    `https://${host}/${context}/mobileapp/teams/${promotionId}/ecards.action`,
    {
      headers: {
        "content-type": "application/json",
        "originated": "teams",
        "post-type": "ajax",
        "outlookauth": appToken,
      },
    }
  );
};

export const saveRecognitation = async (formData) => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  const appToken = localStorage.getItem("appToken");
  return await axios.post(
    `https://${host}/${context}/mobileapp/submitTeamsRecognition.do`,
    formData,
    {
      headers: {
        "content-type": "application/json",
        "originated": "teams",
        "post-type": "ajax",
        "outlookauth": appToken,
      },
    }
  ).catch((error) => {
    if (error) {
     return error.response;
    }
  });
};

export const uploadManualImageUpload = async (formData) => {
  const host = localStorage.getItem("host");
  const context = localStorage.getItem("context");
  const appToken = localStorage.getItem("appToken");
  return await axios.post(
    `https://${host}/${context}/mobileapp/uploadEcardMedia.do`,
    formData,
    {
      headers: {
        "content-type": "application/json",
        "originated": "teams",
        "post-type": "ajax",
        "outlookauth": appToken,
      },
    }
  );
};
